export default __webpack_public_path__ + "media/images/shapes/chevron-down-7caed5701a326265d9e46503922f2227.svg";